module.exports = __webpack_public_path__ + "static/img/anima-logo.7d736dab.svg";